import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscWagesBulkEditAnalyticIds = {
  ascWagesEditInBulkBtnId: string;
  ascWagesExportBulkBtnId: string;
  ascWagesUploadBulkInputId: string;
  ascWagesUploadBulkBtnId: string;
  ascWagesCancelBulkBtnId: string;
};

export const useAscWagesBulkEditAnalyticIds = (): AscWagesBulkEditAnalyticIds => ({
  ascWagesEditInBulkBtnId: useAnalyticId(AnalyticIdentifier.ASC_WAGES_LAYOUT_EDIT_IN_BULK_BUTTON),
  ascWagesExportBulkBtnId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_DOWNLOAD_ASC_WAGES_REPORT_LINK),
  ascWagesUploadBulkInputId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_UPLOAD_ASC_WAGES_REPORT),
  ascWagesUploadBulkBtnId: useAnalyticId(AnalyticIdentifier.ASC_WAGES_LAYOUT_UPLOAD_BULK_BUTTON),
  ascWagesCancelBulkBtnId: useAnalyticId(AnalyticIdentifier.ASC_WAGES_LAYOUT_CANCEL_BULK_BUTTON),
});
